import {
  FilterTypeGlte,
  RenderTableFilterOptionProps,
} from '@monetize/types/common';
import { FunctionComponent as FC } from 'react';
import { MHStack } from '../../chakra';
import { MCurrencyInput } from '../../MCurrencyInput';
import MText from '../../MText';

export const AmountTableFilterOptionContent: FC<
  RenderTableFilterOptionProps
> = ({ filter, filterOption, handleFilterChange }) => {
  const internalFilter = filter as FilterTypeGlte;

  return (
    <MHStack>
      <MCurrencyInput
        value={internalFilter?.value?.min || ''}
        placeholder="Min"
        onChange={(val) =>
          handleFilterChange(
            {
              ...internalFilter?.value,
              min: val,
            },
            filterOption,
          )
        }
      />
      <MText>-</MText>
      <MCurrencyInput
        value={internalFilter?.value?.max || ''}
        placeholder="Max"
        onChange={(val) =>
          handleFilterChange(
            {
              ...internalFilter?.value,
              max: val,
            },
            filterOption,
          )
        }
      />
    </MHStack>
  );
};
